import { gql } from "gql";

export const NOTIFICATION_NUMBER_SUBSCRIPTION = gql(`
  subscription NotificationNumberSubscription {
    personNotificationCountSubscription
  }  
`);
